import React, { useState, useEffect } from 'react';
import Spinner from "react-bootstrap/Spinner";
import ReactPlayer from 'react-player/youtube'
import { dragElement } from '../Utils/index';
import "../css/reactvideomodal.css";

const ReactPlayerWrapper = ({
    width, height, url, latestLoadingUpdate, deviceType
}) => {
    const [isLoading, setIsLoading] = useState(false)
    const [reactPlayerClassName, setreactPlayerClassName] = useState(``)

    
    const detectLongTouch = () => {
        var onlongtouch; 
        var timer;
        var touchduration = 800; //length of time we want the user to touch before we do something

        function touchstart(e) {
            e.preventDefault();
            if (!timer) {
                timer = setTimeout(onlongtouch, touchduration);
            }
        }

        function touchend() {
            //stops short touches from firing the event
            if (timer) {
                clearTimeout(timer);
                timer = null;
            }
        }

        onlongtouch = function () {
            timer = null;
            dragElement(document.getElementById("draggable"));
        };

        document.addEventListener("DOMContentLoaded", function(event) { 
            window.addEventListener("touchstart", touchstart, false);
            window.addEventListener("touchend", touchend, false);
        });
    }

    
    useEffect(() => {
        setIsLoading(true)
        setreactPlayerClassName(`react-player-class-container loader-present`)

        /** handles drag of modal */
        dragElement(document.getElementById("draggable"));

        if(deviceType && deviceType === 'mobile') {
            detectLongTouch()
        }
    }, [])

    useEffect(() => {
        !isLoading && setreactPlayerClassName(`react-player-class-container`)
        isLoading && setreactPlayerClassName(`react-player-class-container loader-present`)

        /** send loader variable updates back to parent, for css use */
        latestLoadingUpdate(isLoading)

    }, [isLoading])

    return (
        <>
            {isLoading && <Spinner className="fallback-react-player" animation="border" variant="primary" />}
            {/* {iframeError && <div className="error-div">Please try again later.</div>} */}
            {/* {!isLoading && !iframeError && <ReactPlayer */}
            {reactPlayerClassName && <ReactPlayer
                className={reactPlayerClassName}
                width={'inherit'}
                height={'inherit'}
                url={url}
                muted={true} // chrome supposrts muted videos only to be autoplayed
                playing={true}
                controls={true}
                onReady={() => setIsLoading(false)}
                onPlay={() => {
                    setIsLoading(false)
                    setIsLoading(false)
                }}
            />}
        </>
    );
}

export default ReactPlayerWrapper;